export default "__VITE_ASSET__BUanwZ65__"